module.exports = __webpack_public_path__ + "img/bookings.cfaafdd8.svg";